import React, { useState } from 'react';
import { COMMERCIAL_DRUGS } from '../data/commercialDrugs';
import drugData from '../data/drugs.json';

export default function DoseHelper() {
    const [weight, setWeight] = useState('');
    const [species, setSpecies] = useState('dog');
    const [selectedDrug, setSelectedDrug] = useState(COMMERCIAL_DRUGS[0]);
    const [result, setResult] = useState(null);

    // Kedi/Köpek İkonu
    const animalIcon = species === 'dog' ? '🐕' : '🐈';

    const handleCalculate = () => {
        if (!weight || weight <= 0) {
            alert("Lütfen hastanın ağırlığını (kg) giriniz.");
            return;
        }

        // Klinik Veri Eşleştirme
        const clinicalDrug = drugData.find(d => 
            d.id.toLowerCase().trim() === selectedDrug.drugId.toLowerCase().trim()
        );

        if (!clinicalDrug) {
            alert(`${selectedDrug.drugId} için veritabanında klinik doz bulunamadı.`);
            return;
        }

        // Seçilen türe göre dozu al
        const rawDoseText = species === 'dog' ? clinicalDrug.dosage_dog : clinicalDrug.dosage_cat;
        
        if (!rawDoseText) {
            alert(`Bu etken madde için ${species === 'dog' ? 'Köpek' : 'Kedi'} doz bilgisi tanımlanmamış.`);
            return;
        }

        // --- Pratik Doz Öncelikli Ayrıştırma ---
        const parseDose = (text) => {
            if (!text) return 0;

            const lowerText = text.toLowerCase();
            const pratikIndex = lowerText.indexOf('pratik doz');
            let searchText = text;
            if (pratikIndex !== -1) {
                searchText = text.substring(pratikIndex);
            }

            const kgMgMatch = searchText.match(/(\d+(?:\.\d+)?)\s*kg.*?(\d+(?:\.\d+)?)\s*mg/i);
            if (kgMgMatch) {
                const kg = parseFloat(kgMgMatch[1]);
                const mg = parseFloat(kgMgMatch[2]);
                if (kg > 0) {
                    return mg / kg; // mg/kg değeri
                }
            }

            const firstNumberMatch = text.match(/(\d+(?:\.\d+)?)/);
            return firstNumberMatch ? parseFloat(firstNumberMatch[0]) : 0;
        };

        let targetDose = parseDose(rawDoseText);

        // μg (mikrogram) kontrolü ve mg dönüşümü
        const isMicrogram = rawDoseText.toLowerCase().includes('μg') || rawDoseText.toLowerCase().includes('microgram');
        if (isMicrogram) {
            targetDose = targetDose / 1000;
        }

        if (targetDose > 0) {
            const totalRequiredMg = parseFloat(weight) * targetDose;
            const finalVolume = totalRequiredMg / selectedDrug.mg_ml;

            setResult({
                volume: finalVolume.toFixed(2),
                mg: totalRequiredMg.toFixed(2),
                type: selectedDrug.type, // ml, tablet vb.
                drugName: selectedDrug.label,
                clinicalDose: isMicrogram ? (targetDose * 1000).toFixed(0) + " μg/kg" : targetDose + " mg/kg"
            });
        } else {
            alert("Dozaj verisi ayrıştırılamadı.");
        }
    };

    return (
        <div style={containerStyle}>
            <h2 style={{ textAlign: 'center', color: '#2c3e50', marginBottom: '5px' }}>⚖️ Doz Hesaplayıcı</h2>
            <p style={{ textAlign: 'center', color: '#7f8c8d', fontSize: '13px', marginBottom: '25px' }}>Ticari Preparat & Etken Madde Analizi</p>

            <div style={cardStyle}>
                {/* --- TÜR SEÇİMİ --- */}
                <div style={speciesContainer}>
                    <button 
                        onClick={() => { setSpecies('dog'); setResult(null); }} 
                        style={species === 'dog' ? activeSpecies : inactiveSpecies}
                    >
                        🐕 KÖPEK
                    </button>
                    <button 
                        onClick={() => { setSpecies('cat'); setResult(null); }} 
                        style={species === 'cat' ? activeSpecies : inactiveSpecies}
                    >
                        🐈 KEDİ
                    </button>
                </div>

                {/* --- KİLO VE İLAÇ GİRİŞİ --- */}
                <div style={inputGrid}>
                    <div style={inputGroup}>
                        <label style={labelStyle}>CANLI AĞIRLIK (KG)</label>
                        <input 
                            type="number" 
                            value={weight} 
                            onChange={(e) => setWeight(e.target.value)} 
                            style={inputStyle} 
                            placeholder="0.0"
                        />
                    </div>

                    <div style={inputGroup}>
                        <label style={labelStyle}>TİCARİ PREPARAT</label>
                        <select 
                            style={selectStyle} 
                            value={COMMERCIAL_DRUGS.indexOf(selectedDrug)}
                            onChange={(e) => setSelectedDrug(COMMERCIAL_DRUGS[e.target.value])}
                        >
                            {COMMERCIAL_DRUGS.map((drug, index) => (
                                <option key={index} value={index}>{drug.label}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* --- HESAPLA BUTONU --- */}
                <button onClick={handleCalculate} style={calcBtn}>DOZU HESAPLA</button>

                {/* --- SONUÇ KARTI --- */}
                {result && (
                    <div style={resultBox}>
                        <div style={{borderBottom:'1px solid #eee', paddingBottom:'10px', marginBottom:'10px'}}>
                            <strong style={{color:'#2c3e50', fontSize:'18px'}}>{result.drugName}</strong>
                            <div style={{fontSize:'13px', color:'#7f8c8d'}}>Klinik Doz: {result.clinicalDose}</div>
                        </div>
                        
                        <div style={{display:'flex', justifyContent:'space-around', alignItems:'center', flexWrap: 'wrap', gap: '10px'}}>
                            <div>
                                <div style={miniLabel}>TOPLAM ETKEN</div>
                                <div style={miniValue}>{result.mg} mg</div>
                            </div>
                            <div style={{fontSize:'24px', color:'#bdc3c7', display: window.innerWidth < 400 ? 'none' : 'block'}}>→</div>
                            <div>
                                <div style={miniLabel}>UYGULANACAK HACİM</div>
                                <div style={mainResult}>{result.volume} {result.type}</div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

// --- CSS STİLLERİ (Mobil ve iOS Safe-Area Uyumlu) ---
const containerStyle = { 
    padding: '15px', 
    maxWidth: '500px', 
    margin: '0 auto', 
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    boxSizing: 'border-box',
    width: '100%',
    paddingTop: 'max(15px, env(safe-area-inset-top))', 
    paddingBottom: 'env(safe-area-inset-bottom)'       
};

const cardStyle = { 
    background: '#fff', 
    padding: '20px', 
    borderRadius: '20px', 
    boxShadow: '0 10px 30px rgba(0,0,0,0.08)', 
    border: '1px solid #f1f2f6',
    boxSizing: 'border-box'
};

const speciesContainer = { display: 'flex', gap: '15px', marginBottom: '25px' };
const activeSpecies = { flex: 1, padding: '12px', background: '#2c3e50', color: '#fff', border: 'none', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer', boxShadow: '0 4px 10px rgba(44, 62, 80, 0.3)', transition: '0.3s', WebkitTapHighlightColor: 'transparent' };
const inactiveSpecies = { flex: 1, padding: '12px', background: '#ecf0f1', color: '#95a5a6', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: 'bold', WebkitTapHighlightColor: 'transparent' };

const inputGrid = { display: 'flex', flexDirection: 'column', gap: '15px' };
const inputGroup = { display: 'flex', flexDirection: 'column' };
const labelStyle = { fontSize: '11px', fontWeight: '800', color: '#7f8c8d', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' };

const inputStyle = { 
    padding: '14px', 
    border: '2px solid #dfe6e9', 
    borderRadius: '10px', 
    fontSize: '16px', 
    outline: 'none', 
    transition: 'border 0.3s', 
    textAlign: 'center', 
    fontWeight: 'bold', 
    color: '#2c3e50', 
    width: '100%', 
    boxSizing: 'border-box', 
    WebkitAppearance: 'none' 
};

const selectStyle = { 
    padding: '14px', 
    border: '2px solid #dfe6e9', 
    borderRadius: '10px', 
    fontSize: '15px', 
    outline: 'none', 
    background: '#fff', 
    color: '#2c3e50', 
    cursor: 'pointer', 
    width: '100%', 
    boxSizing: 'border-box',
    WebkitAppearance: 'none'
};

const calcBtn = { width: '100%', padding: '16px', marginTop: '15px', background: 'linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)', color: '#fff', border: 'none', borderRadius: '12px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', boxShadow: '0 5px 15px rgba(46, 204, 113, 0.3)', letterSpacing: '0.5px', WebkitTapHighlightColor: 'transparent', boxSizing: 'border-box' };

const resultBox = { marginTop: '30px', padding: '20px', background: '#f0fff4', borderRadius: '16px', textAlign: 'center', border: '1px solid #c3e6cb', boxSizing: 'border-box' };
const miniLabel = { fontSize: '10px', color: '#27ae60', fontWeight: 'bold', textTransform: 'uppercase' };
const miniValue = { fontSize: '16px', fontWeight: 'bold', color: '#2c3e50' };
const mainResult = { fontSize: '24px', fontWeight: '900', color: '#e74c3c' };